export default function setTextAccCommentAction(commentCon) {
    return {
        type: 'SET_COMMENT_CON',
        payload: commentCon
    }
}